import React from 'react';
import { useLocation } from 'react-router-dom';

// 全局获取 router 就绪时间（可在根组件或全局布局组件中使用）
export function useRouterReadyTime() {
  const location = useLocation();

  React.useEffect(() => {
    // 路由变化时（初始加载 + 切换），记录当前时间为 router 就绪时间
    if (location.pathname) performance.mark(`ROUTER_READY_P3`);
  }, [location.pathname]); // 仅当路径变化且稳定后执行
}